module.exports = __webpack_public_path__ + "img/BonnieofStrength.3208a84c.png";